'use strict';

exports.__esModule = true;

var _objectToCss = require('./object-to-css');

var _objectToCss2 = _interopRequireDefault(_objectToCss);

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { 'default': obj }; }

exports['default'] = {
    timestamp: (0, _objectToCss2['default'])({
        lineHeight: 2,
        padding: '2px 0',
        color: '#3B5998',
        background: '#EDEFF4'
    }),
    namespace: (0, _objectToCss2['default'])({
        lineHeight: 2,
        color: '#036F96'
    }),
    level: {
        trace: (0, _objectToCss2['default'])({
            lineHeight: 2,
            padding: '2px 5px',
            border: '1px solid #4F8A10',
            color: '#4F8A10',
            background: '#DFF2BF'
        }),
        debug: (0, _objectToCss2['default'])({
            lineHeight: 2,
            padding: '2px 5px',
            border: '1px solid #222',
            color: '#222',
            background: '#FFF'
        }),
        info: (0, _objectToCss2['default'])({
            lineHeight: 2,
            padding: '2px 5px',
            border: '1px solid #00529B',
            color: '#00529B',
            background: '#BDE5F8'
        }),
        warn: (0, _objectToCss2['default'])({
            lineHeight: 2,
            padding: '2px 5px',
            border: '1px solid #9F6000',
            color: '#9F6000',
            background: '#EFEFB3'
        }),
        error: (0, _objectToCss2['default'])({
            lineHeight: 2,
            padding: '2px 5px',
            border: '1px solid #D8000C',
            color: '#D8000C',
            background: '#FFBABA'
        })
    }
};